import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { useAddEncumbranceModal } from '../context/AddEncumbranceModalContext';

const AddEncumbranceModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddEncumbranceModal();

  const hasInvalidRange =
    data.from > data.to || data.from < data.shareFrom || data.to > data.shareTo;

  const isEditingWithoutChanges =
    data.modalActionType === actionTypes.EDIT && !data.hasBeenEdited;

  const isButtonDisabled =
    !data.selectedEncumbranceTypeOption ||
    !data.date ||
    hasInvalidRange ||
    isEditingWithoutChanges;

  return (
    <Modal.Footer>
      <Button
        onClick={actions.handleSave}
        text={t('Save')}
        disabled={isButtonDisabled}
        lgSize
      />
    </Modal.Footer>
  );
};

export default AddEncumbranceModalFooter;
